import { createTypes, actionCreator } from 'redux-action-creator';
import { parseJSON, handleNetworkError } from '../../utils'


export const employerDeclarationTypes = createTypes(['REQUEST', 'RECEIVE', 'ERROR', 'SUCCESS'], 'EMPLOYER_DECLARATION');


export const requestEmployerDeclaration = () => {
    return {
        type: employerDeclarationTypes.REQUEST,
    };
};

export const receiveEmployerDeclaration = (response) => {
    return {
        type: employerDeclarationTypes.RECEIVE,
        data: response,
    };
};

export const receiveEmployerDeclarationError = (response) => {
    return {
        type: employerDeclarationTypes.ERROR,
        error: response,
    };
};

export const fetchEmployerDeclaration = (employerId, dateFrom, dateTo) => {
    return dispatch => {
        let apiUrl = `/api/v1/employer/${employerId}?date_from=` + dateFrom + `&date_to=`+ dateTo 

        dispatch(requestEmployerDeclaration());

        let headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        }

        return fetch(apiUrl, {
            headers: headers,
            credentials: 'include',
        })
        .then(parseJSON)
        .then(response => {
            try {
                dispatch(receiveEmployerDeclaration(response));
            } catch (e) {
                dispatch(receiveEmployerDeclarationError(response));
            }
        })
        .catch(handleNetworkError);
    };
};